module.exports = __webpack_public_path__ + "duplicate-reviews.svg?925dfcb8ff62e98f7fa9ee03a33ae734";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/duplicate-reviews.svg
// module id = 287
// module chunks = 2